import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "empty-state"
}


import { storeToRefs } from 'pinia';
import { defineAsyncComponent, ref, shallowRef } from 'vue';
import { useContractsStore } from '~store/contracts/contractsModule';
import AppLoader from '@/components/AppLoader.vue';
import { ITab } from '@/types';

const __default__ = { name: 'TabsWrapper' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tabs: ITab[] = [
  {
    id: 1, // 4
    label: 'Заключения',
    tabName: 'conclusions',
    componentName: 'BaseTab',
    event: 'GET:ZA_doc_list.module_calculation',
  },
  {
    id: 2, // 1
    label: 'Документы',
    tabName: 'documents',
    componentName: 'BaseTab',
    event: 'GET:doc_list.module_calculation',
  },
  {
    id: 3, // 2
    label: 'Услуги',
    tabName: 'services',
    componentName: 'BaseTab',
    event: 'GET:services_list',
  },
  {
    id: 6,
    label: 'расчеты',
    tabName: 'calculations',
    componentName: 'BaseTab',
    event: 'GET:contract_calculations.module_calculation',
  },
  {
    id: 5,
    label: 'Менеджеры',
    tabName: 'managers',
    componentName: 'ManagersTab',
    event: 'GET:agents_by_contract',
  },
];

const { currentContractId } = storeToRefs(useContractsStore());

const activeTabId = ref(1);
const activeTab = ref(tabs.find((item) => item.id === activeTabId.value) as ITab);
const activeTabComponent = shallowRef(
  defineAsyncComponent(() => import(`./${activeTab.value.componentName}.vue`)),
);

const onTabSelect = (val: number) => {
  activeTabId.value = val;
  activeTab.value = tabs.find((item) => item.id === activeTabId.value) as ITab;
  activeTabComponent.value = defineAsyncComponent(
    () => import(`./${activeTab.value.componentName}.vue`),
  );
};

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_tabs, {
      class: "text-accent",
      "onUpdate:modelValue": [
        onTabSelect,
        _cache[0] || (_cache[0] = ($event: any) => ((activeTabId).value = $event))
      ],
      modelValue: activeTabId.value
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
          return _createVNode(_component_q_tab, _mergeProps({
            key: tab.id,
            name: tab.id
          }, tab), null, 16, ["name"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(currentContractId) !== null)
      ? (_openBlock(), _createBlock(_component_q_tab_panels, {
          key: 0,
          animated: "",
          "model-value": activeTabId.value
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
              return _createVNode(_component_q_tab_panel, {
                key: tab.id,
                name: tab.id
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_Suspense, null, {
                    fallback: _withCtx(() => [
                      _createVNode(_component_q_inner_loading, {
                        showing: true,
                        label: "Идет загрузка..."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(AppLoader)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      (activeTabId.value)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(activeTabComponent)), {
                            key: 0,
                            tabName: activeTab.value.tabName,
                            event: activeTab.value.event,
                            contractId: _unref(currentContractId)
                          }, null, 8, ["tabName", "event", "contractId"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                ]),
                _: 2
              }, 1032, ["name"])
            }), 64))
          ]),
          _: 1
        }, 8, ["model-value"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, "Договор не выбран"))
  ], 64))
}
}

})